
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

import { Place } from 'shared/topchef.types';

import evenLinkLogo from 'assets/images/linkevent-logo.png';

export interface PlacesMenuProps {
  loggedInPlace: Place,
}

const PlacesMenu = ({loggedInPlace}: PlacesMenuProps) => {
  const { t } = useTranslation();
  const lochallHelpUrl = String(t('externalUrls.lochall.help'));

  return (
    <div id="sidebar" data-testid="places-menu" className="d-flex flex-column flex-shrink-0 p-3 pt-5 bg-light vh-100 justify-content-between" style={{width: 250}}>
      <div className="row g-3">
        <div id="profil_sidebar">
          <div id="app_title" className="d-flex align-items-center">    
              <img src={evenLinkLogo} alt="LinkEvents logo" className="" style={{width: 150}} />
          </div>
        <div id="host_infos" className="row gap-1 mt-3">
            <span className="listing-name fw-bold">{loggedInPlace.name}</span>
            <div className="lochall_points">     
                <span>{t('nav.lochallPoints')}</span>
                <span className="lochall_points_count" >{loggedInPlace.locHallPoints}</span>
            </div>
        </div>
      </div>
        <div id="dashboard_sidebar">
          <span className="text-left">{t('nav.dashboard')}</span>
          <ul className="nav nav-pills flex-column mb-auto">
              <li className="nav-item"><Link to={'dashboard'} className="nav-link dashboard-link">{t('nav.dashboard')}</Link></li>
              <li className="nav-item"> <Link to={'shared-leads'} className="nav-link sended-brief-link">{t('nav.sharedBriefs')}</Link></li>
              <li className="nav-item"> <Link to={'available-leads'} className="nav-link briefs-market-link">{t('nav.availableBriefs')}</Link></li>
              {loggedInPlace.acceptReward &&
              <>
                <li className="nav-item"> <Link to={'leads/followed'} className="nav-link progress-brief-link">{t('nav.briefsToProcess')}</Link></li>
                <li className="nav-item"> <Link to={'leads/to-close'} className="nav-link achieved-brief-link">{t('nav.signedBriefsToClose')}</Link></li>
                <li className="nav-item"> <Link to={'share-a-lead'} className="nav-link add-brief-link">{t('common.addBrief')}</Link></li>
              </>}
              {loggedInPlace.acceptReward === false &&
              <>
                <li className="nav-item"> <Link to={'leads/followed'} className="nav-link followed-brief-link">{t('nav.followedBriefs')}</Link></li>
              </>}
          </ul>
        </div>
        <div id="gestion_sidebar" className="">
          <span className="text-left">{t('nav.management')}</span>
          <ul className="nav nav-pills flex-column mb-auto">
              <li className="nav-item"><Link to={'my-account'} className="nav-link profil-link" >{t('nav.myAccount')}</Link></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li className="nav-item"><Link to={lochallHelpUrl} target="_blank" className="nav-link faq-link">{t('nav.help')}</Link></li>
          </ul>
        </div>
      </div>
    </div>

  );

}

export default PlacesMenu;
